import { Routes } from '@angular/router';
import { MessagingComponent } from './components/messaging';
import { CallbackComponent } from './components/callback';
import { WelcomeComponent } from './components/welcome';
import { authGuard } from './auth.guard'
import { Logout } from './components/logout';

export const routes: Routes = [
  { path: '', component: WelcomeComponent },
  { path: 'messaging', component: MessagingComponent, canActivate: [authGuard] },
  { path: 'callback', component: CallbackComponent },
  { path: 'logout', component: Logout },
  { path: '**', redirectTo: '' }
];
